<template>
  <div
    class="logos"
    :class="`logos--${ overlap }`"
    @click.prevent="$emit('click')"
  >
    <a
      class="logo"
      href="/"
    >
      <logo/>
    </a>
    <a
      class="logo--fixed"
      href="/"
    >
      <logo class="logo-big"/>
      <logo-mini class="logo-mini"/>
    </a>
  </div>
</template>

<script>
import Logo from '@/components/Logo'
import LogoMini from '@/components/LogoMini'

export default {
  components: {
    Logo,
    LogoMini
  },
  props: {
    overlap: {
      type: String,
      default: 'hero'
    }
  }
}
</script>

<style lang="scss" scoped>
  .logos {
    @include grid-container;
    position: relative;
    z-index: 10;
  }

.logo {
  position: absolute;
  @include page-offset(top);
  z-index: 2;
  @each $breakpoint-name, $space in $grid-space-around {
    @include media-up($breakpoint-name) {
      transform: translateX( #{$space/-2} );
    }
  }
  svg {
    fill: #fff;
    width: 109px;

    @include media-down(md) {
      fill: #000;
    }

    @include media-up(md) {
      width: 179px;
    }

    @include media-up(lg) {
      width: $logo-width;
    }
  }

    .active-menu & {
      svg {
        fill: #fff;
      }
    }
  }

  .active-menu .logo,
  .logo--fixed {
    position: fixed;
    transform-origin: right top;
    transform: translateX(-100%) rotate(-90deg);
    transition: opacity .15s;
  }

  .logo--fixed {
    z-index: 1;
    left: 0;
    display: flex;
    align-items: center;
    @include page-offset(margin-top);
    @each $breakpoint-name, $space in $grid-space-around {
      @include media-up($breakpoint-name) {
        height: $space;
      }
    }
    svg {
      height: 33.333%;
      fill: #000;
      transition: fill .15s;
    }
    @include media-up(xl) {
      left: calc( (100% - #{$grid-container-width}) / 2 );
    }
    @include media-down(md) {
      transform: none;
      height: auto;
      justify-content: center;
      @each $breakpoint-name, $space in $grid-space-around {
        @include media-up($breakpoint-name) {
          width: $space;
        }
      }
      svg {
        width: $logo-mini-width;
        height: auto;
        fill: #fff;
      }

  }
}

.active-menu {
  .logo--fixed {
    display: none!important;
  }
  .logo {
    z-index: 1;
    left: 0;
    display: flex;
    align-items: center;
    @each $breakpoint-name, $space in $grid-space-around {
      @include media-up($breakpoint-name) {
        height: $space;
      }
    }
  }
}

.logo-big {
  @include hide-down(md);
}
.logo-mini {
  @include hide-up(md);
}

  .logos {
    &--hero .logo--fixed {
      opacity: 0;
      pointer-events: none;
    }

    &--about .logo--fixed svg {
      fill: #fff;
    }

    &--projects .logo--fixed svg,
    &--manifest .logo--fixed svg,
    &--contact .logo--fixed svg {
      fill: #000
    }
  }

  .logo,
  .logo--fixed {
    outline: none;
    transition: opacity .15s;

    &:hover,
    &:focus {
      opacity: .9;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderLogos.vue